/* eslint-disable */

import { useContext, useRef } from 'react';
import { StoreContext } from '../stores/storeContext';
import { useNavigate } from 'react-router-dom';

export function useViewModel(ViewModel: any, ...args: any[]): any {
	const vmRef = useRef(null);

	const storeProvider = useContext(StoreContext);
	const navigate = useNavigate();

	if (!vmRef.current) {
		vmRef.current = new ViewModel(storeProvider, navigate, ...args);
	}

	return vmRef.current;
}
